import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment/moment";
import DateTimeBox from "../../../primer/DateTimeBox";
import {
    newDclInitialValue,
    setNewDcl
} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import Dropdown from "../../../primer/Dropdown";
import {getAvailableServiceTypes, isEmpty} from "../../../../_helpers/commonFunctions";
import {clientServiceTypes} from "../../../../_data/mydata/clientServiceTypes";
import TextArea from "../../../common/TextArea";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {Popover} from "antd";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewClientModal from "../Clients/new-client-modal";
import {vehicleCategoryOptions} from "../../../../_data/mydata/vehicleCategoryOptions";
import {vehicleMovementPurposeOptions} from "../../../../_data/mydata/vehicleMovementPurposeOptions";
import {postNewDcl} from "../../../../_apis/api";
import {toast} from "react-toastify";
import Alert from "react-bootstrap/Alert";
import RecognizePlateModal from "./RecognizePlateModal";
import {useTranslation} from "../../../../hooks/useTranslation";
import CountryDropdown from "../../../primer/Dropdown/CountryDropdown";

const NewDclModal = ({show, setShow, companyInstallations}) => {
    const apiURL2 = process.env.REACT_APP_API_URL2;
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.DCL.dclRequestData);
    const newDclData = useSelector((state) => state.DCL.newDcl);
    const dclInstallationDefaultOptions = useSelector((state) => state.SALES_SETTINGS?.salesGeneralSettings?.dclInstallationDefaultOptions);
    const [loader, setLoader] = useState(false);
    const [clientsListData, setClientsListData] = useState([]);
    const [dclListData, setDclListData] = useState([]);
    const [vehicleInfoLoader, setVehicleInfoLoader] = useState(false);
    const [showRecognizeModal, setShowRecognizeModal] = useState(false);
    const currentYear = String(company.year);

    const handleCloseModal = () => {
        setShow(false);
    };
    const clientDropdownColumns = [
        {label: t('SalesNew.clientTable.code'), name: "systemCode"},
        {label: t('SalesNew.clientTable.name'), name: "name"},
        {label: t('SalesNew.clientTable.phone'), name: "phone"},
        {label: t('SalesNew.clientTable.email'), name: "email"},
        {label: t('SalesNew.clientTable.vatNumber'), name: "vatNumber"}
    ];
    const dclListDropdownColumns = [
        {label: "Πινακίδα Οχήματος", name: "vehicleRegistrationNumber"},
        {label: "Ημερομηνία Εγγραφής", name: "creationDateTime"},
        {label: "Πελάτης", name: "clientName"},
        {label: "Κατηγορία Υπηρεσίας", name: "serviceCategory", options: [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής"}]},
        {label: "Κατάσταση", name: "status", options: [{value: "open", label: "Εκκρεμείς"}, {value: "completed", label: "Ολοκληρωμένη"}, {value: "cancelled", label: "Ακυρωμένη"}]},
    ]
    useEffect(() => {
        if(show) {
            loadClientsListData(null, setClientsListData);
            loadDclListData(null, setDclListData);
            if(requestData) {
                let initialValues = {...newDclInitialValue, clientServiceType: requestData.clientServiceType, installation: requestData.installation, creationDateTime: currentYear !== moment().format("YYYY") ? "" : moment().toDate()};
                const settings = dclInstallationDefaultOptions?.find((el) => el?.installation === requestData.installation);
                if(!isEmpty(settings)) {
                    initialValues.serviceCategory = settings?.serviceCategory || "";
                }
                dispatch(setNewDcl(initialValues));
            }
        }
    }, [show]);

    const loadClientsListData = (keyword, setData) => {
        let reqData = {company: company.id};
        if (!isEmpty(keyword)) reqData.keyword = keyword;
        if(newDclData?.serviceCategory === "recurring") reqData.onlyWholeshale = true;
        axios.post(process.env.REACT_APP_API_URL2 + `/dcl/dcl-list-client`, reqData, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    let filteredData = res.data.data;
                    if (setData) setData(filteredData);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const loadDclListData = (keyword, setData) => {
        let reqData = {company: company.id};
        if (!isEmpty(keyword)) reqData.keyword = keyword;
        axios.post(process.env.REACT_APP_API_URL2 + `/dcl/dcl-list-correlated`, reqData, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    let filteredData = res.data.data;
                    if (setData) setData(filteredData);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }



    const handleOnChange = (e, type = "default", ddname = '') => {
        let name;
        let value;
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e ? moment(e).format("DD/MM/YYYY") : "";
            name = ddname;
        } else if (type === "dtb") {
            value = e ? moment(e).toDate() : "";
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === "acb") {
            if(ddname === "clientName") {
                dispatch(setNewDcl({...newDclData, client: e.row._id, clientName: e.row.name, clientVatNumber: e.row.vatNumber, clientCountry: e.row.country, clientCategory: e.row.category}));
                return;
            } else if(ddname === "correlatedDclId") {
                dispatch(setNewDcl({...newDclData, correlatedDclObj: e.row._id, correlatedDclId: e.row.dclId, correlatedDclName: `${e.row.vehicleRegistrationNumber} - ${e.row.clientName} - ${moment(e.row?.creationDateTime).format("DD/MM/YYYY HH:mm")} (${e.row?.dclId})`}));
                return;
            } else {
                value = e.target.value;
                name = ddname;
            }
        } else if (type === "cb") {
            value = e.target.checked;
            name = ddname;
        } else if(type === "inputNumber") {
            value = e.target.value.replace(/[^0-9]/g, '');
            name = e.target.name;
        } else if(type === "inputRegistrationNumber") {
            value = e.target.value.replace(/[^a-zA-Z0-9\u0370-\u03FF\u1F00-\u1FFF]/g, '').toUpperCase();
            name = e.target.name;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let newDcl = Object.assign({}, newDclData);
        newDcl[name] = value;
        if(name === "fromAgreedPeriodDate" && moment(value, "DD/MM/YYYY").isAfter(moment(newDcl?.toAgreedPeriodDate, "DD/MM/YYYY"))) {
            newDcl["toAgreedPeriodDate"] = "";
        }
        if(name === "creationDateTime") {
            newDcl["transmissionFailure"] = "1";
        }
        dispatch(setNewDcl(newDcl));
    }


    useEffect(() => {
        if(newDclData?.runCheckAfterRecognize) {
            checkRegistrationNumber();
        }
    }, [newDclData?.runCheckAfterRecognize]);

    const checkRegistrationNumber = async () => {
        let dclData = {...newDclData};
        if(!isEmpty(newDclData?.vehicleRegistrationNumber)) {
            setVehicleInfoLoader(true);
            await axios.post(apiURL2 + `/dcl/get-vehicle-info`, {plateNumber: newDclData?.vehicleRegistrationNumber}, {
                headers: { "Content-Type": "application/json" },
            }).then(async (res) => {
                if (res.data.status === "200") {
                        dclData.vehicleCategory = res.data.data?.vehicle_type?.trim();
                        dclData.vehicleFactory = `${res.data.data["make"]?.trim()} ${res.data.data?.colour?.trim()}`;
                    toast.success("Ο Έλεγχος Πινακίδας ολοκληρώθηκε με επιτυχία!");
                } else {
                    toast.error(res.data && res.data.message);
                }
                setVehicleInfoLoader(false);
            }).catch(async (error) => {
                console.log(error);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                setVehicleInfoLoader(false);
            })
        } else {
            toast.error("Παρακαλώ εισάγετε Πινακίδα Οχήματος!");
        }
        dispatch(setNewDcl({...dclData, runCheckAfterRecognize: false}))
    }

    const createNewDcl = () => {
        // validation check
        if(
            isEmpty(newDclData?.creationDateTime) ||
            isEmpty(newDclData?.clientServiceType) ||
            isEmpty(newDclData?.serviceCategory) ||
            isEmpty(newDclData?.vehicleRegistrationNumber) ||
            isEmpty(newDclData?.vehicleCategory) ||
            isEmpty(newDclData?.vehicleFactory) ||
            isEmpty(newDclData?.vehicleCountry) ||
            isEmpty(newDclData?.client)) {
            return toast.error("Παρακαλώ συμπληρώστε όλα τα απαραίτητα πεδία!");
        }
        if((newDclData?.serviceCategory === "continuous" || newDclData?.serviceCategory === "continuousLease") && (isEmpty(newDclData?.fromAgreedPeriodDate) || isEmpty(newDclData?.toAgreedPeriodDate))) {
            return toast.error("Παρακαλώ συμπληρώστε συμφωνημένη περίοδο για διαρκή υπηρεσία / Λήψη Δικαιώματος!");
        }
        if(newDclData?.serviceCategory === "continuousLease" && isEmpty(newDclData?.periodicity) && isEmpty(newDclData?.periodicityOther)) {
            return toast.error("Παρακαλώ συμπληρώστε περιοδικότητα για διαρκή Μίσθωση/Υπηρεσία!");
        }
        if(newDclData?.clientServiceType === "1" && isEmpty(newDclData?.vehicleMovementPurpose)) {
            return toast.error("Παρακαλώ εισάγετε Σκοπό Κίνησης Οχήματος");
        }
        if(newDclData?.clientServiceType === "1" && newDclData?.isDiffVehPickupLocation && isEmpty(newDclData?.vehiclePickupLocation)) {
            return toast.error("Παρακαλώ εισάγετε Τόπο Παραλαβής Οχήματος");
        }
        if(Number(newDclData?.periodicity) > 12) {
            return toast.error("Η περιοδικότητα δεν μπορεί να ξεπερνάει την τιμή 12");
        }
        if(newDclData?.serviceCategory === "recurring" && (newDclData?.vehicleMovementPurpose === "2" || newDclData?.vehicleMovementPurpose === "3")) {
            return toast.error("Στην περίπτωση της επαναλαμβανόμενης υπηρεσίας, τότε ο σκοπός κίνησης δεν μπορεί να είναι Ιδιόχρηση ή Δωρεάν Υπηρεσία");
        }
        let postData = Object.assign({}, newDclData);
        postData.company = company.id;
        if(newDclData?.transmissionFailure !== "1") postData.creationDateTime = moment().toDate();
        dispatch(postNewDcl(postData, setLoader, requestData, setShow));
    }




    return (
        <React.Fragment>
            <Modal className={"themeModalBig"} backdrop={"static"} show={show} onHide={() => handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>Νέα Εγγραφή Πελάτη</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted mb-2"><i>Στοιχεία Εγγραφής:</i></p>
                    <Row>
                        <Col md={4}>
                            <DateTimeBox
                                classes="w-100"
                                label={newDclData?.clientServiceType === "1" ? "Ημερομηνία και Ώρα Αναχώρησης Οχήματος" : "Ημερομηνία και Ώρα Εισόδου Οχήματος"}
                                name="creationDateTime"
                                required={true}
                                minDate={moment(currentYear, "YYYY").startOf("year").toDate()}
                                maxDate={currentYear !== String(moment().format("YYYY")) ? moment(currentYear, "YYYY").endOf("year").toDate() : moment().add(3, 'hours').toDate()}
                                selected={moment(newDclData?.creationDateTime).isValid() ? moment(newDclData?.creationDateTime, "DD/MM/YYYY HH:mm:ss").toDate() : null}
                                onChange={(e) => handleOnChange(e, 'dtb', 'creationDateTime')}
                            />
                        </Col>
                        <Col md={4}>
                            <Dropdown
                                name={"clientServiceType"}
                                label={"Τύπος Ψηφιακού Πελατολογίου"}
                                className={"w-100"}
                                required={true}
                                defaultValue={clientServiceTypes.find((el) => el.value === newDclData.clientServiceType)}
                                key={Math.random()}
                                disabled={true}
                                options={clientServiceTypes}
                                onChange={(e) => dispatch(setNewDcl({...newDclData, clientServiceType: e.value}))}
                            />
                        </Col>
                        <Col md={4}>
                            <Dropdown
                                name={"installationMasterId"}
                                label={"Εγκατάσταση"}
                                defaultValue={companyInstallations.find((el) => el.value === newDclData.installation)}
                                key={Math.random()}
                                disabled={true}
                                required={true}
                                className={"w-100 mb-2"}
                                options={companyInstallations}
                                onChange={(e) => dispatch(setNewDcl({...newDclData, installation: e.value}))}
                            />
                        </Col>
                    </Row>
                    {newDclData?.transmissionFailure === "1" && (
                        <Alert variant={"secondary"} className={"mb-1"} style={{color: "#fe7c96"}}>
                            Προσοχή! Η εγγραφή πελάτη θα αποσταλεί με σήμανση "Αδυναμίας Σύνδεσης" λόγω ετεροχρονισμένης ημερομηνίας εισόδου οχήματος.
                            <Button size={"sm"} onClick={() => dispatch(setNewDcl({...newDclData, creationDateTime: currentYear !== moment().format("YYYY") ? "" : moment().toDate(), transmissionFailure: ""}))} style={{position: "absolute", right: "5px", top: "5px"}}>Επαναφορά</Button>
                        </Alert>
                    )}
                    <hr/>
                    <p className="text-muted mb-2"><i>Στοιχεία Οχήματος:</i></p>
                    <Row>
                        <Col md={5}>
                            <div style={{ display: "flex", alignItems: "center"}}>
                                <CountryDropdown
                                    className={"mt-1"}
                                    selected={newDclData.vehicleCountry}
                                    defaultValue={newDclData.vehicleCountry}
                                    onChange={(code) => dispatch(setNewDcl({...newDclData, vehicleCountry: code}))}
                                />
                                <Input
                                    className={"ml-2 mb-1"}
                                    label={"Πινακίδα Οχήματος"}
                                    style={{display: "inline"}}
                                    charLimit={50}
                                    name={"vehicleRegistrationNumber"}
                                    placeholder={"Εισάγετε Πινακίδα Οχήματος"}
                                    type={"text"}
                                    required={true}
                                    value={newDclData.vehicleRegistrationNumber}
                                    onChange={(e) => handleOnChange(e, "inputRegistrationNumber", "vehicleRegistrationNumber")}
                                />
                                <Button
                                    disabled={newDclData.vehicleCountry !== "GR"}
                                    className={"ml-2 mt-3"}
                                    style={{padding: "5px"}}
                                    variant="primary"
                                    onClick={() => checkRegistrationNumber()}>
                                    Έλεγχος Πινακίδας
                                    {vehicleInfoLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                </Button>
                                {/*
                                <Button
                                    className={"ml-2 mt-3"}
                                    style={{padding: "5px"}}
                                    variant="primary"
                                    onClick={() => setShowRecognizeModal(true)}>
                                    Αναγνώριση Πινακίδας <FaCamera size={15} />
                                </Button> */}
                            </div>
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                label={"Κατηγορία Οχήματος"}
                                required={true}
                                defaultValue={vehicleCategoryOptions.find((el) => el.value === newDclData.vehicleCategory)}
                                key={Math.random()}
                                options={vehicleCategoryOptions}
                                onChange={(e) => handleOnChange(e, 'dd', 'vehicleCategory')}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                label={"Κατασκευαστής - Μοντέλο Οχήματος"}
                                name={"vehicleFactory"}
                                charLimit={100}
                                placeholder={"Εισάγετε Μοντέλο Οχήματος"}
                                type={"text"}
                                required={true}
                                value={newDclData.vehicleFactory}
                                onChange={(e) => handleOnChange(e, "input", "vehicleFactory")}
                            />
                        </Col>
                    </Row>
                    {newDclData?.clientServiceType === "1" && (
                        <Row>
                            <Col md={4}>
                                <Dropdown
                                    label={"Σκοπός Κίνησης Οχήματος"}
                                    required={true}
                                    defaultValue={vehicleMovementPurposeOptions.find((el) => el.value === newDclData.vehicleMovementPurpose)}
                                    key={Math.random()}
                                    options={vehicleMovementPurposeOptions}
                                    onChange={(e) => handleOnChange(e, 'dd', 'vehicleMovementPurpose')}
                                />
                            </Col>
                            <Col md={4}>
                                <div style={{marginTop: "33px"}}>
                                    <BetterCheckBox
                                        name={"isDiffVehPickupLocation"}
                                        text={"Διαφορετικός Τόπος Παραλαβής Οχήματος"}
                                        checked={newDclData?.isDiffVehPickupLocation}
                                        onChange={(e) => handleOnChange(e, 'cb', 'isDiffVehPickupLocation')}
                                    />
                                </div>
                            </Col>
                            {newDclData?.isDiffVehPickupLocation && (
                                <Col md={4}>
                                    <Input
                                        label={"Τόπος Παραλαβής Οχήματος"}
                                        name={"vehiclePickupLocation"}
                                        charLimit={250}
                                        placeholder={"Εισάγετε Τόπο Παραλαβής Οχήματος"}
                                        type={"text"}
                                        required={true}
                                        value={newDclData.vehiclePickupLocation}
                                        onChange={(e) => handleOnChange(e, "input", "vehiclePickupLocation")}
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                    <hr/>
                    <p className="text-muted mb-2"><i>Στοιχεία Υπηρεσίας:</i></p>
                    <Row>
                        <Col md={3}>
                            <Dropdown
                                label={"Κατηγορία Υπηρεσίας"}
                                required={true}
                                defaultValue={getAvailableServiceTypes(newDclData?.clientServiceType).find((el) => el.value === newDclData.serviceCategory)}
                                key={Math.random()}
                                options={getAvailableServiceTypes(newDclData?.clientServiceType)}
                                onChange={(e) => handleOnChange(e, 'dd', 'serviceCategory')}
                            />
                        </Col>
                        {newDclData?.clientServiceType === "2" && (
                            <Col md={2}>
                                <Popover placement={"top"} content={
                                    <div style={{maxWidth: "400px", textAlign: 'center'}}>
                                        Επιλέγεται σε περίπτωση που παρέχονται ταυτόχρονα υπηρεσίες στάθμευσης και πλυσίματος στο όχημα.
                                    </div>
                                } title={<div style={{textAlign: "center"}}>Μικτή Υπηρεσία</div>}>
                                    <div style={{marginTop: "33px"}}>
                                <BetterCheckBox
                                    name={"mixedService"}
                                    text={"Μικτή Υπηρεσία"}
                                    checked={newDclData?.mixedService}
                                    onChange={(e) => handleOnChange(e, 'cb', 'mixedService')}
                                />
                                    </div>
                                </Popover>
                            </Col>
                        )}
                        {(newDclData?.serviceCategory === "continuous" || newDclData?.serviceCategory === "continuousLease") && (
                            <React.Fragment>
                                <Col md={3}>
                                    <DateBox
                                        name={"fromAgreedPeriodDate"}
                                        required={true}
                                        label={"Έναρξη παρεχόμενης υπηρεσίας"}
                                        allowOtherYears={true}
                                        minDate={new Date()}
                                        selected={moment(newDclData?.fromAgreedPeriodDate, "DD/MM/YYYY").isValid() ? moment(newDclData.fromAgreedPeriodDate, "DD/MM/YYYY").toDate() : ""}
                                        onKeyDown={(e) => e.preventDefault()}
                                        onChange={(e) => handleOnChange(e, "dp", "fromAgreedPeriodDate")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <DateBox
                                        name={"toAgreedPeriodDate"}
                                        required={true}
                                        allowOtherYears={true}
                                        label={"Λήξη παρεχόμενης υπηρεσίας"}
                                        minDate={moment(newDclData?.fromAgreedPeriodDate, "DD/MM/YYYY").isValid() ? moment(newDclData.fromAgreedPeriodDate, "DD/MM/YYYY").toDate() : ""}
                                        selected={moment(newDclData?.toAgreedPeriodDate, "DD/MM/YYYY").isValid() ? moment(newDclData.toAgreedPeriodDate, "DD/MM/YYYY").toDate() : ""}
                                        onKeyDown={(e) => e.preventDefault()}
                                        onChange={(e) => handleOnChange(e, "dp", "toAgreedPeriodDate")}
                                    />
                                </Col>
                            </React.Fragment>
                        )}
                    </Row>
                    {newDclData?.serviceCategory === "continuousLease" && (
                        <Row>
                            <Col md={4}>
                                <Input
                                    label={"Περιοδικότητα Διαρκούς Μίσθωσης/Υπηρεσίας (σε μήνες)"}
                                    name={"periodicity"}
                                    placeholder={"Εισάγετε Περιοδικότητα"}
                                    type={"text"}
                                    required={true}
                                    value={newDclData.periodicity}
                                    onChange={(e) => handleOnChange(e, "inputNumber", "periodicity")}
                                />
                            </Col>
                            <Col md={4}>
                                <Input
                                    label={"Περιοδικότητα Λοιπές"}
                                    name={"periodicityOther"}
                                    charLimit={100}
                                    placeholder={"Εισάγετε Περιοδικότητα Λοιπές"}
                                    type={"text"}
                                    value={newDclData.periodicityOther}
                                    onChange={(e) => handleOnChange(e, "default", "periodicityOther")}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col md={6}>
                            <div className="d-flex justify-content-between">
                                <AdvancedCombobox
                                    name={"clientName"}
                                    className={"w-100 ac-select-dropdown flex-grow-1"}
                                    defaultValue={`${newDclData.clientName}${newDclData.clientVatNumber ? ` (${newDclData.clientVatNumber})` : ""}`}
                                    label={"Πελάτης"}
                                    data={clientsListData}
                                    onChange={(e) => handleOnChange(e, "acb", "clientName")}
                                    key={newDclData.client}
                                    onChangeSearch={(keyword, setData) => loadClientsListData(keyword, setData)}
                                    excludeColumns={[]}
                                    columns={clientDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={"Πληκτρολογήστε και επιλέξτε πελάτη"}
                                    required={true}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                />
                                {newDclData?.client ? (
                                    <button className="btn quick-retail-clientbtn btn-default btn-sm ml-1 mt-4" title="Clear Client" key={Math.random()} onClick={() => dispatch(setNewDcl({...newDclData, client: "", clientName: "", clientVatNumber: "", clientCountry: "", clientCategory: ""}))}><i className="fas fa-xmark"></i></button>
                                ) : (
                                    <div className={'ml-1'} style={{paddingTop: "23px"}}>
                                        <NewClientModal
                                            fromPrescription={false}
                                            successCallback={(data) => dispatch(setNewDcl({...newDclData, client: data._id, clientName: data.name, clientVatNumber: data.vatNumber, clientCountry: data.country, clientCategory: data.category}))} />
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex justify-content-between">
                                <AdvancedCombobox
                                    name={"correlatedDclId"}
                                    className={"w-100 ac-select-dropdown flex-grow-1"}
                                    defaultValue={newDclData?.correlatedDclName}
                                    label={"Συσχέτιση Προηγούμενης Εγγραφής"}
                                    data={dclListData}
                                    onChange={(e) => handleOnChange(e, "acb", "correlatedDclId")}
                                    key={"correlatedDclId" + newDclData.correlatedDclId}
                                    onChangeSearch={(keyword, setData) => loadDclListData(keyword, setData)}
                                    excludeColumns={[]}
                                    columns={dclListDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={"Επιλέξτε Συσχετιζόμενη Εγγραφή"}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                />
                                {newDclData?.correlatedDclId && (
                                    <button className="btn quick-retail-clientbtn btn-default btn-sm mt-4" title="Clear Correlation" key={Math.random()} onClick={() => dispatch(setNewDcl({...newDclData, correlatedDclId: "", correlatedDclName: "", correlatedDclObj: ""}))}><i className="fas fa-xmark"></i></button>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <Col md={12}>
                            <div className={"text-muted mb-2"}><i>Σημειώσεις Εγγραφής</i></div>
                            <TextArea
                                name={"comments"}
                                rows={"4"}
                                limit={150}
                                placeholder={"Εισάγετε Σημειώσεις Εγγραφής"}
                                value={newDclData?.comments ? newDclData?.comments : ""}
                                onChange={(e) => handleOnChange(e, 'default', 'comments')}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => handleCloseModal()}>
                        Κλείσιμο
                    </Button>
                    <Button disabled={loader} variant="primary" onClick={() => createNewDcl()}>
                        Δημιουργία
                        {loader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>
            <RecognizePlateModal show={showRecognizeModal} setShow={setShowRecognizeModal} />
        </React.Fragment>
    )
}

export default NewDclModal;
